<div class="w-full bg-gray-50 py-4 shadow max-lg:hidden md:px-8">
  <ng-content></ng-content>
</div>
